import { APP_INITIALIZER, Provider } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry } from '@angular/material/icon';

import { ICON_NAMES } from './icon-names';

function registerIcons(iconRegistry: MatIconRegistry, sanitizer: DomSanitizer): () => void {
  return () => {
    for (const name of ICON_NAMES) {
      iconRegistry.addSvgIcon(name, sanitizer.bypassSecurityTrustResourceUrl(`assets/icons/${name}.svg`));
    }
  };
}

export const provideIcons: Provider = {
  provide: APP_INITIALIZER,
  useFactory: registerIcons,
  deps: [MatIconRegistry, DomSanitizer],
  multi: true,
};
